angular
	.module 'App.Directive'
	.directive 'passwordRevealIcon', ->
		restrict: 'E'
		require: '^^passwordReveal'
		scope: {}
		template: '''
			<button
				type="button"
				class="password-reveal-icon addon-button"
				tabindex="-1"
				ng-class="{'is-revealed': !parent.state}"
				ng-click="parent.onClick()"
			>
				<span class="fa" ng-class="parent.state === true ? 'fa-eye' : 'fa-eye-slash'"></span>
			</button>
		'''
		link: ($scope, $element, $attributes, parentController) ->
			$scope.parent = parentController

		controller: ($scope, $element, $timeout, MessageTerminal) ->
			$onInit: ->
				if $element.siblings('.addon-button').length != 0
					@setPosition()
					MessageTerminal.on $scope, MessageTerminal.events.DISPLAY_LANGUAGE, => @setPosition()

			# While this element is in same block with additional addon button, update position.
			# Currently this is only case for secret-input while element is displayed and changing language
			setPosition: ->
				$timeout(
					=>
						width = Math.ceil($element.siblings('.addon-button').eq(0).outerWidth() || 100)

						$element.find('.password-reveal-icon').css('right', "#{width}px")
					,
					10
				)
